import http from "../index"

//分页查询我的客户信息
export const getPageCustomerList = param => { return http.post("lab-datacenter/lab/getPageCustomerList", param).then(res => res.data.data) };

//分页查询我的项目映射
export const selectMyMatchListByPage = param => { return http.post("lab-datacenter/lab/selectMyMatchListByPage", param).then(res => res.data.data) };

//新增项目映射
export const addMyMatch = param => { return http.post("lab-datacenter/lab/addMyMatch", param).then(res => res.data.data) };

//删除项目映射
export const delMyMatch = param => { return http.post("lab-datacenter/lab/delMyMatch", param).then(res => res.data.data) };

//修改项目映射
export const updateMyMatch = param => { return http.post("lab-datacenter/lab/updateMyMatch", param).then(res => res.data.data) };

//分页查询实验室样本信息
export const selectMySampleListByPage = param => { return http.post("lab-datacenter/lab/selectMySampleListByPage", param).then(res => res.data.data) };

//报告单图片
export const getReportImg = param => { return http.post("lab-datacenter/dataPlatformManagerHospital/selectReportAttachmentList", param).then(res => res) };

//标本结果
export const getReportResult = param => { return http.post("lab-datacenter/dataPlatformManagerHospital/selectReportDetailList", param).then(res => res) };




// WEBPACK FOOTER //
// ./src/http/laboratory/index.js